<div class="card car-info" *ngIf="carDetails">
  <div class="tw-flex">
    <div class="tw-grow tw-my-2">
      <span  class="tw-text-[10px] tw-mx-3 tw-px-3 tw-py-1 tw-rounded-full tw-bg-grayUltraLight">MAKE YEAR {{carDetails.year}}</span>
    </div>
    <div class="flex-none">
      <span class="available">Available in {{carDetails.availabilityInDays}} days</span>
    </div>
  </div>

  <div class="card-body pt-0">
    <div class="row">
      <!-- Title -->
      <div *ngIf="isPumPumPum" class="col-12 tw-flex tw-items-center">
        <img width="20" src="{{carDetails.brand.icon}}" alt="">&nbsp;
        <span>{{carDetails.brand.name | titlecase}}</span>
      </div>

      <div class="col-12 car-name  d-flex align-items-center tw-mb-4">
        <p class="mt-2 mb-2"><b>{{carDetails.model.name | titlecase}} {{carDetails.variant.name | titlecase}}</b>
        </p>
      </div>
      <ng-container *ngIf="carDetails && carDetails?.pricing?.length">
        <app-price-calculator (tenureChanged)="tenureChanged($event)" (mileageChanged)="mileageChanged($event)"
          [tenures]="carDetails.pricing"></app-price-calculator>
      </ng-container>
      <!-- Action -->
      <div class="col-12 d-grid action">
        <p class="tw-italic tw-mb-1">* Price includes monthly rental, insurance, routine maintenance and taxes for the
          selected duration.</p>
        <button class="tw-bg-yellow tw-py-2 tw-text-white tw-rounded-md hover:tw-bg-yellow-300 tw-uppercase tw-font-bold"
          (click)="requestToSubscribe()" gaEvent="gaEventTag" gaCategory="action_event">
          Request to subscribe &nbsp;
          <fa-icon [icon]="faCheckCircle"></fa-icon>
        </button>
        <button *ngIf="showViewDetails" (click)="viewDetails()" type="button" class="btn btn-link">View full
          details</button>
      </div>
    </div>
  </div>
</div>